import { API } from "@/lib/api";
import { APIService, FetchListRequest } from "@/services/api";
import {
  ReadProjectSettlementsComments,
  WriteProjectSettlementsComments,
} from "@/schemas/projectSettlementsComments";

const ProjectSettlementsCommentsServiceAPI =
  new APIService<ReadProjectSettlementsComments>(API.ProjectSettlements);

export const ProjectSettlementsCommentsService = {
  getList: (
    settlementId: string,
    fetchParams?: FetchListRequest<ReadProjectSettlementsComments>,
  ) =>
    ProjectSettlementsCommentsServiceAPI.getList(
      fetchParams,
      `/${settlementId}/comments`,
    ),
  post: (settlementId: string, values: WriteProjectSettlementsComments) =>
    ProjectSettlementsCommentsServiceAPI.post(
      values,
      `${settlementId}/comments`,
    ),
};
